import app from './modules/app'
import common from './modules/common'
import edsfileview from './modules/edsfileview'
import edsdownloadfileHelper from './modules/edsdownloadfileHelper'
import fs from './modules/fs'
import JPush from './modules/JPush'
import login from './modules/login'
import msgbox from './modules/msgbox'
import sqliteHelper from './modules/sqliteHelper'
import versionCheckHelper from './modules/versionCheckHelper'
import work from './modules/work'

var functions = {
  app,
  common,
  edsfileview,
  edsdownloadfileHelper,
  fs,
  JPush,
  login,
  msgbox,
  sqliteHelper,
  versionCheckHelper,
  work
}

export default functions
